import type { Address } from "@jti/fe-common/types";

export type RawAddressWithNoContactInfo = Omit<Address, "telephone" | "firstname" | "lastname">;
